<template>
	<modal
		:min-width="modalOptions.largura"
		:min-height="modalOptions.altura"
		:exibir="exibir"
		:custom-actions="true"
		:titulo="tituloModal"
		@close="fecharModal"
		:acao-cancelar="fecharModal"
		classe-personalizada-body="padding-body"
		:is-confirmar-visivel="true"
	>
		<template #body>
			<az-container class="mt-0">
				<listagem-itens
					ref="listagemNotificacoesPenalidades"
					:textos-do-template-da-listagem-vazia="textosDaListagemVazia"
					:colunas="getColunas()"
					:itens="itensDatasource"
					:total-paginas="itensTotalPaginas"
					:total-itens="totalItens"
					:paginacao="paginacao"
					:custom-columns="['descricao']"
					@paginar="setPaginacao"
					@resetar-page="resetarPaginaListagem()"
					:tamanho-maximo-colunas="tamanhoMaximoColunas"
				>
					<template #descricao="{ item }">
						<texto-tooltip
							:texto="item.descricao || '---'"
							:tamanho-maximo="tamanhoMaximoColunas.descricao"
						></texto-tooltip>
					</template>
				</listagem-itens>
			</az-container>
		</template>
	</modal>
</template>
<script>
import Modal from '@/views/components/Modal'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import { actionTypes } from '@/core/constants'
import { TabelaColunaUtils } from '@/core/utils'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'
import ListagemItens from '@/views/components/ListagemItens'
import { mapState } from 'vuex'
import TextoTooltip from '@/views/components/TextoTooltip'

export default {
	name: 'modal-historico-notificacoes',
	components: {
		TextoTooltip,
		ListagemItens,
		Modal,
	},
	mixins: [validacaoFormulario],
	props: {
		exibir: {
			type: Boolean,
		},
		modalOptions: {
			type: Object,
			default: () => {
				return { largura: '50%', altura: '80%' }
			},
		},
		item: {
			type: Object,
			default: null,
			required: true,
		},
		entidadeTipo: {
			type: Object,
			required: true,
		},
		tituloModal: {
			type: String,
			default: () => 'Histórico de Notificações',
		},
		textosDaListagemVazia: {
			type: Object,
			default: () => {
				return { titulo: 'Nenhum item por aqui' }
			},
		},
	},
	emits: ['fechar-modal'],
	data() {
		return {
			itensDatasource: [],
			itensTotalPaginas: 0,
			totalItens: 0,
			paginacao: paginacaoListagem('id', 25, 'ASC'),
			tamanhoMaximoColunas: {
				descricao: 40,
				infracao: 20,
				fornecedor: 20,
				siglaOrgao: 10,
			},
		}
	},
	computed: {
		...mapState({
			infoAta: (state) => state.ata.informacoesAta,
		}),
	},
	async mounted() {
		await this.buscarHistoricoNotificacoes()
	},
	methods: {
		async buscarHistoricoNotificacoes() {
			const { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.PENALIDADES.NOTIFICACOES.BUSCAR_NOTIFICACOES_PENALIDADE,
				this.montarObjHistoricoNotificacoes(),
			)

			this.itensDatasource = itens
			this.totalItens = totalElements
			this.itensTotalPaginas = totalPages
		},
		montarObjHistoricoNotificacoes() {
			return {
				tipo: this.entidadeTipo,
				tipoEntidade: this.item.tipoEntidade,
				idPenalidade: this.item.id,
				paginacao: this.paginacao,
			}
		},
		async resetarPaginaListagem() {
			this.paginacao.page = 1
			await this.buscarHistoricoNotificacoes()
		},
		async setPaginacao(paginacao) {
			this.paginacao = paginacao
			await this.buscarHistoricoNotificacoes()
		},
		getColunas() {
			return [
				new TabelaColunaUtils('Infração', 'infracao', '20%'),
				new TabelaColunaUtils('Fornecedor', 'fornecedor', '20%'),
				new TabelaColunaUtils('Órgão', 'siglaOrgao', '14%'),
				new TabelaColunaUtils('Descrição', 'descricao', '36%'),
				new TabelaColunaUtils('Enviado', 'documentoEnviado', '10%'),
			]
		},
		fecharModal() {
			this.$emit('fechar-modal')
		},
	},
}
</script>

<style lang="stylus">
.bg-white
	background-color white

.padding-body
	padding 0 !important

.v-dialog--active:has(.hidden-overflow)
	overflow hidden !important

.padding-right-14
	padding-right 14px

.background-color
	background-color #F2F7FA
</style>
